import type {
  MetricsTrendsResponse,
  TrendDataPoint,
} from "../../../../../shared/api/types";

export const transformTrendsData = (
  data: MetricsTrendsResponse | undefined,
  metrics: string[]
): Array<Record<string, string | number | null>> => {
  if (!data?.data?.trend || data.data.trend.length === 0) return [];

  return data.data.trend.map((point: TrendDataPoint) => {
    const transformed: Record<string, string | number | null> = {
      period: point.period,
      label: point.label,
      // Bucket bounds retained so chart event markers can map an ISO event date
      // to the bucket that contains it (see mapEventsToAxis / AnnotatableChart).
      period_start: point.period_start,
      period_end: point.period_end,
    };

    metrics.forEach((metric) => {
      const value = point[metric];
      if (value !== null && value !== undefined) {
        const numValue = typeof value === "number" ? value : Number(value);
        transformed[metric] = Math.round(numValue * 10) / 10;
      } else {
        transformed[metric] = null;
      }

      const sdKey = `${metric}_sd`;
      const sdValue = point[sdKey];
      if (sdValue !== null && sdValue !== undefined) {
        const numSd = typeof sdValue === "number" ? sdValue : Number(sdValue);
        transformed[sdKey] = isFinite(numSd) ? Math.round(numSd * 100) / 100 : null;
      } else {
        transformed[sdKey] = null;
      }

      for (const suffix of ["_min", "_max"] as const) {
        const key = `${metric}${suffix}`;
        const raw = point[key];
        if (raw !== null && raw !== undefined) {
          const n = typeof raw === "number" ? raw : Number(raw);
          transformed[key] = isFinite(n) ? Math.round(n * 10) / 10 : null;
        } else {
          transformed[key] = null;
        }
      }
    });

    return transformed;
  });
};
